

export const OneDayPresentation = ({ lang }) => {
  const tours = ['antigua', 'lago', 'tikal', 'pacaya', 'city', 'mont', 'playa',];
  return (
    <div className="one-day-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/oneDayTours/${tour}${lang.charAt(0).toUpperCase() + lang.slice(1)}.jpg`} className={`one-day-tour-presentation-img`} alt={tour} key={`${i}-One-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
